<template>
  <div>
    <PageTitle title="Hall Enquiries" />
    <v-container fluid>
      <v-card>
        <v-card-title>Website banquet hall enquiries</v-card-title>
        <v-container fluid>
          <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
          <v-data-table
            :headers="headers"
            :items="rows"
            :loading="loading"
            item-key="id"
            :items-per-page="15"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ when(item.createdAt) }}
            </template>
            <template v-slot:item.name="{ item }">
              <div>{{ item.name }}</div>
              <v-chip v-if="!item.seenAt" x-small color="red" text-color="white">
                New
              </v-chip>
            </template>
            <template v-slot:item.notes="{ item }">
              {{ item.notes || "—" }}
            </template>
            <template v-slot:no-data>
              <div class="py-4 text-center">No hall enquiries yet</div>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import http from "@/plugins/axios";

export default {
  data: () => ({
    rows: [],
    loading: false,
    error: "",
    headers: [
      { text: "Received", value: "createdAt" },
      { text: "Reference", value: "reference" },
      { text: "Hall", value: "hallName" },
      { text: "Event", value: "eventType" },
      { text: "Date", value: "eventDate" },
      { text: "Guests", value: "guests" },
      { text: "Name", value: "name" },
      { text: "Phone", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Notes", value: "notes" },
    ],
  }),
  created() {
    this.load();
    this.$root.$on("hall-enquiries-refresh", this.load);
  },
  beforeDestroy() {
    this.$root.$off("hall-enquiries-refresh", this.load);
  },
  methods: {
    when(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString();
    },
    load() {
      this.loading = true;
      this.error = "";
      http
        .get("hms/hall-enquiries")
        .then((res) => {
          this.rows = Array.isArray(res.data) ? res.data : [];
        })
        .catch(() => {
          this.error = "Could not load hall enquiries.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
